import { render, staticRenderFns } from "./SurveyEditPage.vue?vue&type=template&id=1438cbb0&scoped=true"
import script from "./SurveyEditPage.vue?vue&type=script&lang=js"
export * from "./SurveyEditPage.vue?vue&type=script&lang=js"
import style0 from "./SurveyEditPage.vue?vue&type=style&index=0&id=1438cbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438cbb0",
  null
  
)

export default component.exports